import { all, call, /*  call, */ fork, put, takeLatest } from 'redux-saga/effects'
import store from 'store'
import actionTypes from '../action-types'
import callFetchApi from '../../services/api'
import commonService from '../../services/common-service'

const mockData = {
    "data": {
        "id": "691960739e31aa3fb8c6c278",
        "token": "eyJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE3NjM4MjA3NzcsImV4cCI6MTc2MzkwNzE3N30.0IjuMqF9AWZyWmIfnozRa-aJn-r21e3RkBIbzEaD7wt_GP1f76Fa1ZShCs1897lfOl1MplaOKO_9D3ZX2Uxk_A",
        "type": "Bearer",
        "username": null,
        "email": "9952064495",
        "roles": [
            "ROLE_CUSTOMER"
        ],
        "privilege": null,
        "customer": null,
        "customerInfo": {
            "customerId": "691960739e31aa3fb8c6c279",
            "firstName": "",
            "lastName": "",
            "email": null,
            "countryCode": "+91",
            "mobile": "9952064495",
            "addresses": []
        }
    },
    "status": 200,
    "statusText": "",
    "headers": {
        "cache-control": "no-cache, no-store, max-age=0, must-revalidate",
        "content-type": "application/json",
        "expires": "0",
        "pragma": "no-cache"
    },
    "config": {
        "url": "http://localhost:8082/api/auth/otp/verify",
        "method": "post",
        "params": {},
        "data": "{\"mobile\":\"9952064495\",\"code\":\"+91\",\"otp\":\"76765\"}",
        "headers": {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": "application/json"
        },
        "transformRequest": [
            null
        ],
        "transformResponse": [
            null
        ],
        "timeout": 0,
        "xsrfCookieName": "XSRF-TOKEN",
        "xsrfHeaderName": "X-XSRF-TOKEN",
        "maxContentLength": -1
    },
    "request": {}
}
export function* generateOtpSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_OTP_BEING_SENT,
        payload: true,
    })
    const { url, data } = action.payload
    const response = yield call(callFetchApi, url, {}, 'POST', data)
    yield put({
        type: actionTypes.IS_OTP_BEING_SENT,
        payload: false,
    })
    yield put({
        type: actionTypes.IS_OTP_SENT,
        payload: true,
      })
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: actionTypes.IS_OTP_SENT,
        payload: true,
      })
    } else {
      const { errors } = response?.data
      console.log({errors})
    }
  } catch (error) {
    console.log({error})
    commonService.showNotification('error', 'OTP not sent. Please try again later', '')
    yield put({
        type: actionTypes.IS_OTP_BEING_SENT,
        payload: false,
    })
  }
}

export function* verifyOtpSaga(action) {
  try {
    yield put({
        type: actionTypes.IS_OTP_BEING_VERIFIED,
        payload: true,
    })
    const { url, data } = action.payload
    const response = yield call(callFetchApi, url, {}, 'POST', data)
    yield put({
        type: actionTypes.IS_OTP_BEING_VERIFIED,
        payload: false,
    })
    
    if (response.status === 200 || response.status === 201) {
      localStorage.setItem('npipl_token_hash', response.data.body.token)
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_INFO,
        payload: response.data.body.customerInfo,
      })
      yield put({
        type: actionTypes.UPDATE_CUSTOMER_LOGGED_IN,
        payload: true,
      })
      yield put({
        type: actionTypes.IS_OTP_VERIFIED,
        payload: true,
      })
      commonService.showNotification('success', '', 'Otp Verified! Login Success.')
    } else if (response.status === 400) {
      commonService.showNotification('error', '', 'Otp error!')
      yield put({
        type: actionTypes.SET_OTP_ERROR_MESSAGE,
        payload: response.data,
      })
    }
  } catch (error) {
    console.log({error})
    commonService.showNotification('error', 'OTP verification failed. Please try again later', '')
    yield put({
        type: actionTypes.IS_OTP_BEING_VERIFIED,
        payload: false,
    })
  }
}

function* watchGenerateOtpSaga() {
  yield takeLatest(actionTypes.GENERATE_OTP, generateOtpSaga)
}

function* watchVerifyOtpSaga() {
  yield takeLatest(actionTypes.VERIFY_OTP, verifyOtpSaga)
}

export default function* customerSagas() {
  yield all([
    fork(watchGenerateOtpSaga),
    fork(watchVerifyOtpSaga),
  ])
}
